export const modelIdsTextV107 = (modelIds) => modelIds.join(',');

const safeBaseUrlV107 = (value) => {
  if (!value) return '';
  try {
    const url = new URL(value);
    url.username = '';
    url.password = '';
    for (const key of [...url.searchParams.keys()]) {
      if (/key|token|secret|password|authorization/i.test(key)) {
        url.searchParams.delete(key);
      }
    }
    url.hash = '';
    return url.toString();
  } catch {
    return '';
  }
};

export const channelModelsTextV107 = (channel, modelIds, t) =>
  [
    `${t('channel.edit.copy_v107.name')}: ${channel?.name || ''}`,
    `${t('channel.edit.copy_v107.id')}: ${channel?.id || t('channel.edit.copy_v107.unsaved')}`,
    `${t('channel.edit.copy_v107.groups')}: ${Array.isArray(channel?.group) ? channel.group.join(',') : channel?.group || ''}`,
    `Base URL: ${safeBaseUrlV107(channel?.base_url) || t('channel.edit.copy_v107.default_url')}`,
    `${t('channel.edit.copy_v107.models')}: ${modelIdsTextV107(modelIds)}`,
  ].join('\n');
